/**
 * Common
 */
export const TOASTR_ADD = 'TOASTR_ADD';
export const TOASTR_REMOVE = 'TOASTR_REMOVE';
export const TOASTR_RESET = 'TOASTR_RESET';
export const SIDEBAR_EXPANDED_SET = 'SIDEBAR_EXPANDED_SET';

/**
 * Auth
 */
export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const TOKEN_VERIFY = 'TOKEN_VERIFY';
export const TOKEN_VERIFY_SUCCESS = 'TOKEN_VERIFY_SUCCESS';
export const TOKEN_VERIFY_FAIL = 'TOKEN_VERIFY_FAIL';

/**
 * Navigation
 */
export const NAV_SECTION_SET = 'NAV_SECTION_SET';

/**
 * User
 */
export const USER_FETCH = 'USER_FETCH';
export const USER_FETCH_SUCCESS = 'USER_FETCH_SUCCESS';
export const USER_FETCH_FAIL = 'USER_FETCH_FAIL';
export const USER_SAVE = 'USER_SAVE';
export const USER_SAVE_SUCCESS = 'USER_SAVE_SUCCESS';
export const USER_SAVE_FAIL = 'USER_SAVE_FAIL';
export const USER_CHANGE_ORGANIZATION = 'USER_CHANGE_ORGANIZATION';
export const USER_CHANGE_ORGANIZATION_SUCCESS = 'USER_CHANGE_ORGANIZATION_SUCCESS';
export const USER_CHANGE_ORGANIZATION_FAIL = 'USER_CHANGE_ORGANIZATION_FAIL';
export const CREATE_USER = 'CREATE_USER';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAIL = 'CREATE_USER_FAIL';

/**
 * Organization
 */
export const ORGANIZATION_FETCH = 'ORGANIZATION_FETCH'
export const ORGANIZATION_FETCH_SUCCESS = 'ORGANIZATION_FETCH_SUCCESS'
export const ORGANIZATION_FETCH_FAIL = 'ORGANIZATION_FETCH_FAIL'
export const ORGANIZATION_SAVE = 'ORGANIZATION_FETCH_SAVE'
export const ORGANIZATION_SAVE_SUCCESS = 'ORGANIZATION_SAVE_SUCCESS'
export const ORGANIZATION_SAVE_FAIL = 'ORGANIZATIONN_SAVE_FAIL'

/**
 * Partner
 */
export const PARTNER_FETCH = 'PARTNER_FETCH'
export const PARTNER_FETCH_SUCCESS = 'PARTNER_FETCH_SUCCESS'
export const PARTNER_FETCH_FAIL = 'PARTNER_FETCH_FAIL'
export const PARTNER_SAVE = 'PARTNER_FETCH_SAVE'
export const PARTNER_SAVE_SUCCESS = 'PARTNER_SAVE_SUCCESS'
export const PARTNER_SAVE_FAIL = 'PARTNERN_SAVE_FAIL'
export const FETCH_PARTNER_USERS = 'FETCH_PARTNER_USERS';
export const FETCH_PARTNER_USERS_SUCCESS = 'FETCH_PARTNER_USERS_SUCCESS';
export const FETCH_PARTNER_USERS_FAIL = 'FECH_PARTNER_USERS_FAIL';

/**
 * Events
 */
export const SELECT_EVENT = 'SELECT_EVENT';
export const EVENT_FETCH = 'EVENT_FETCH';
export const EVENT_FETCH_SUCCESS = 'EVENT_FETCH_SUCCESS';
export const EVENT_FETCH_FAIL = 'EVENT_FETCH_FAIL';
export const EVENTS_FETCH = 'EVENTS_FETCH';
export const EVENTS_FETCH_SUCCESS = 'EVENTS_FETCH_SUCCESS';
export const EVENTS_FETCH_FAIL = 'EVENTS_FETCH_FAIL';
export const PARTNER_PORTAL_SETTINGS_FETCH = 'PARTNER_PORTAL_SETTINGS_FETCH';
export const PARTNER_PORTAL_SETTINGS_FETCH_SUCCESS = 'PARTNER_PORTAL_SETTINGS_FETCH_SUCCESS';
export const PARTNER_PORTAL_SETTINGS_FETCH_FAIL = 'PARTNER_PORTAL_SETTINGS_FETCH_FAIL';

/**
 * Shop / Cart
 */
export const CHECKOUT_REQUEST = 'CHECKOUT_REQUEST'
export const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS'
export const CHECKOUT_FAIL = 'CHECKOUT_FAIL'
export const COMPARE_PRODUCT = 'COMPARE_PRODUCT';
export const FETCH_PRODUCT = 'FETCH_PRODUCT';
export const FETCH_PRODUCT_SUCCESS = 'FETCH_PRODUCT_SUCCESS';
export const FETCH_PRODUCT_FAIL = 'FETCH_PRODUCT_FAIL';
export const FETCH_PRODUCT_CATEGORIES = 'FETCH_PRODUCT_CATEGORIES';
export const FETCH_PRODUCT_CATEGORIES_SUCCESS = 'FETCH_PRODUCT_CATEGORIES_SUCCESS';
export const FETCH_PRODUCT_CATEGORIES_FAIL = 'FETCH_PRODUCT_CATEGORIES_FAIL';
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_FAIL = 'FETCH_PRODUCTS_FAIL';
export const SET_SELECTED_PRODUCT = 'SET_SELECTED_PRODUCT'
export const SET_VIEW_PRODUCT_ID = 'SET_VIEW_PRODUCT_ID'
export const FETCH_PRODUCT_BUNDLES = 'FETCH_PRODUCT_BUNDLES';
export const FETCH_PRODUCT_BUNDLES_SUCCESS = 'FETCH_PRODUCT_BUNDLES_SUCCESS';
export const SHOP_SORT_BY = 'SHOP_SORT_BY';
export const SET_SELECTED_PRODUCT_CATEGORY = 'SET_SELECTED_PRODUCT_CATEGORY';
export const ADD_PRODUCT_TO_CART = 'ADD_PRODUCT_TO_CART';
export const REMOVE_PRODUCT_FROM_CART = 'REMOVE_PRODUCT_FROM_CART';
export const UPDATE_CART = 'UPDATE_CART';
export const CLEAR_CART = 'CLEAR_CART';
export const SET_QUANTITY = 'SET_QUANTITY';
export const SET_PRODUCT_SEARCH_TERM = 'SET_PRODUCT_SEARCH_TERM';
export const OPEN_CART_LIST_DRAWER = 'OPEN_CART_LIST_DRAWER';
export const CLOSE_CART_LIST_DRAWER = 'CLOSE_CART_LIST_DRAWER';
export const FETCH_CART = 'FETCH_CART';
export const FETCH_CART_SUCCESS = 'FETCH_CART_SUCCESS';
export const FETCH_CART_FAIL = 'FETCH_CART_FAIL';
export const SET_CART_ITEM = 'SET_CART_ITEM';
export const SET_PRODUCT_QUANTITY = 'SET_PRODUCT_QUANTITY';

/**
 * Orders
 */
export const FETCH_ORDERS = 'FETCH_ORDERS';
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_FAIL = 'FETCH_ORDERS_FAIL';
export const FETCH_ORDER = 'FETCH_ORDER';
export const FETCH_ORDER_SUCCESS = 'FETCH_ORDER_SUCCESS';
export const FETCH_ORDER_FAIL = 'FETCH_ORDER_FAIL';
export const UPDATE_ORDER = 'UPDATE_ORDER';
export const UPDATE_ORDER_SUCCESS = 'UPDATE_ORDER_SUCCESS';
export const UPDATE_ORDER_FAIL = 'UPDATE_ORDER_FAIL';
export const SET_ORDERS_META = 'SET_ORDERS_META';
export const SET_ORDER_ROWS_META = 'SET_ORDER_ROWS_META';

/**
 * Notifications
 */
export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS';
export const FETCH_NOTIFICATIONS_FAIL = 'FETCH_NOTIFICATIONS_FAIL';
